module.exports = __webpack_public_path__ + "static/media/nimbus_logo.bbc306b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/nimbus_logo.png
// module id = 2445
// module chunks = 0